export type OfficeStatisticsRow = {
  label: string;
  value: number;
};

export function buildOfficeStatisticsRows({
  officeCount,
  professionals,
  staff,
  pressReleases,
  publishedArticles,
  distinctOpenGroups,
  distinctPrivateGroups,
  distinctOpenGroupsParticipants,
  distinctPrivateGroupsParticipants,
}: {
  officeCount: number;
  professionals: number;
  staff: number;
  pressReleases: number;
  publishedArticles: number;
  distinctOpenGroups: number;
  distinctPrivateGroups: number;
  distinctOpenGroupsParticipants: number;
  distinctPrivateGroupsParticipants: number;
}): OfficeStatisticsRow[] {
  return [
    { label: "Number of Offices", value: officeCount },
    { label: "Number of Professionals", value: professionals },
    { label: "Number of Staff", value: staff },
    { label: "Press Releases", value: pressReleases },
    { label: "Published Articles", value: publishedArticles },
    { label: "Distinct Open Groups", value: distinctOpenGroups },
    { label: "Distinct Private Group", value: distinctPrivateGroups },
    {
      label: "Distinct Open Groups Participants",
      value: distinctOpenGroupsParticipants,
    },
    {
      label: "Distinct Private Groups Participants",
      value: distinctPrivateGroupsParticipants,
    },
  ];
}
